// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-bulletin-js": () => import("./../src/templates/bulletin.js" /* webpackChunkName: "component---src-templates-bulletin-js" */),
  "component---src-templates-page-js": () => import("./../src/templates/page.js" /* webpackChunkName: "component---src-templates-page-js" */),
  "component---src-templates-graphs-and-maps-js": () => import("./../src/templates/graphs-and-maps.js" /* webpackChunkName: "component---src-templates-graphs-and-maps-js" */),
  "component---src-pages-404-js": () => import("./../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-admin-js": () => import("./../src/pages/admin.js" /* webpackChunkName: "component---src-pages-admin-js" */),
  "component---src-pages-index-js": () => import("./../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

